import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Component/Navbar/Navbar";
import "./App.css";
import Home from "./Home/Home";
import Footer from "./Component/Footer/Footer";
import Projects from "./Project/Projects";
import Skills from "./Skills/Skills";
import About from "./About/About";
import Contact from "./Contact/Contact";



const Connect = () => {
  // WhatsApp link with prefilled message
  const phone = "918980614160";
  const message = encodeURIComponent("i! Hii 👋 , Ritesh Gajjar.");
  const whatsappUrl = `https://wa.me/${phone}?text=${message}`;

  return (
    <div style={{ textAlign: "center", marginTop: "3rem" }}>
      <h2>Connect with me on WhatsApp</h2>
      <p>
        <strong>Number:</strong> +91 8980614160
      </p>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          marginTop: "1.5rem",
          background: "#25D366",
          color: "#fff",
          padding: "0.8rem 2rem",
          borderRadius: "2rem",
          fontWeight: 600,
          fontSize: "1.1rem",
          textDecoration: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.13)",
          transition: "background 0.2s"
        }}
      >
        Message: i! Hii 👋 , Ritesh Gajjar.
      </a>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Navbar />
      <div style={{ paddingTop: "80px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects/*" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/connect" element={<Connect />} />
          
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;

